import { useMemo } from 'react';
import {
  ClaimscoreLogoLarge,
  ClaimscoreLogoSmall,
  Stack,
  useBreakpoints,
  useTheme,
} from 'ui';
import {
  ListBox,
  LogoBox,
  SidebarBox,
  StyledMenuOpenIcon,
} from './MainSideNavbarContent.styles';
import { SIDENAVBAR_CONTENT_WRAPPER } from './SideNavbar.testIds';
import { useMainSideNavbarNavItems } from './useMainSideNavbarNavItems';

export interface MainSideNavbarContentProps {
  readonly open?: boolean;
  readonly onClose?: () => void;
}

export function MainSideNavbarContent({
  open,
  onClose,
}: MainSideNavbarContentProps) {
  const theme = useTheme();
  const { isMdUp } = useBreakpoints();
  const mainSideNavbarNavItems = useMainSideNavbarNavItems();

  const getSideNavbarBoxContent = useMemo(() => {
    if (open) {
      return (
        <LogoBox>
          <ClaimscoreLogoLarge
            aria-label="ClaimScore Logo"
            color={theme.palette.paper[200]}
          />
          {!isMdUp && (
            <StyledMenuOpenIcon aria-label="menu-open-icon" onClick={onClose} />
          )}
        </LogoBox>
      );
    }
    return (
      <LogoBox>
        <ClaimscoreLogoSmall
          aria-label="ClaimScore Logo"
          color={theme.palette.paper[200]}
        />
      </LogoBox>
    );
  }, [open, theme.palette.paper, isMdUp, onClose]);

  return (
    <Stack data-testid={SIDENAVBAR_CONTENT_WRAPPER} width="100%">
      <SidebarBox>{getSideNavbarBoxContent}</SidebarBox>
      <ListBox>{mainSideNavbarNavItems}</ListBox>
    </Stack>
  );
}
